import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  CircularProgress,
  Skeleton,
  Tooltip,
} from "@mui/material";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import AddToListModal from "./AddToListModal";
import { useDispatch, useSelector } from "react-redux";
import { Circles } from "react-loader-spinner";
import Swal from "sweetalert2";
import {
  loadEnrichData,
  loadGetPhone,
  updateAisearchedContacts,
  webHookGetPhone,
} from "../redux/ai_connect/ai_action";
import { toast } from "react-toastify";
import { aiBaseUrl } from "../BaseURL";
import { useState } from "react";
import { emailAccessFail, emailAccessSuccess } from "../CommonFile/SVGIcons";

dayjs.extend(relativeTime);

export default function SelectedSearchFilterTable({
  setPage,
  loadingSearch,
  searchContactData = [],
  totalDataCount,
  loading,
  responseTime,
  loadingMore,
  setLoadingMore,
  tableHeight,
  selectedRowsData,
  setSelectedRowsData,
  setShowAddToListModal,
  showAddToListModal,
  selectedRowIds,
  setSelectedRowIds,
}) {
  const dispatch = useDispatch();
  const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
  const { getCredits } = useSelector((state) => state.data);

  const [loadingRows, setLoadingRows] = useState({});
  const [loadingPhoneRows, setLoadingPhoneRows] = useState({});
  const [isSelectAll, setIsSelectAll] = useState(false);

  const insertEnrichedContact = async (person) => {
    if (!person || !person.id) return;

    const firstName =
      person.first_name ||
      person.firstName ||
      (person.name || "").split(" ")[0];

    if (!firstName) {
      console.warn("Skip insert – no firstname", person);
      toast.warning("Enrichment returned incomplete data");
      return;
    }

    const insertPayload = {
      user_id: parseInt(signInDetails[0]?.id),
      user_name: signInDetails[0]?.name,
      sbn_id: signInDetails[0]?.sbn_id,
      list_name: "Default",
      enrichData: person, // full enriched object from API
    };

    // try {
    //   const res = await fetch(`${aiBaseUrl}ai/enrich_data_insert`, {
    //     method: "POST",
    //     headers: { "Content-Type": "application/json" },
    //     body: JSON.stringify(insertPayload),
    //   });
    //   const data = await res.json();
    //   console.log("enrich_data_insert response =>", data);

    //   if (data?.status !== 200) {
    //     toast.warning(data?.message || "Contact enriched but failed to save to list");
    //   }
    // } catch (err) {
    //   console.error("enrich_data_insert error:", err);
    // }
  };

  // region unlock phone number
  const handlePhoneUnlock = async (
    uiRowId,
    email_status,
    provider = "apollo"
  ) => {
    const result = await Swal.fire({
      title: "Enrich Phone?",
      html: `
      <div style="text-align: center; line-height: 1.6;">
        <p style="font-size: 16px; color: #555; margin-bottom: 20px;">
          ${email_status === false ? "9" : "9"} credit will be used to unlock this phone.
        </p>
        <div style="
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          padding: 16px;
          margin-bottom: 20px;
        ">
          <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
            <span>📞 Phone Credits</span>
            <strong>${email_status === false ? "9" : "9"} Credits</strong>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
            <span>✉️ Email Credits</span>
            <strong>Free</strong>
          </div>
        </div>
        <p style="font-size: 14px; color: #64748b;">
          Proceeding will deduct these credits from your account.
        </p>
      </div>
    `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Unlock",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#2563eb",
      cancelButtonColor: "#dc2626",
      reverseButtons: true,
      focusCancel: true,
      width: "500px",
      customClass: {
        popup: "rounded-xl",
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    });

    if (!result.isConfirmed) return;

    try {
      if (getCredits.credits_aval < 9) {
        toast.warning(
          `You dont have enough credits to unlock the phone. Please upgrade the plan`
        );
        return;
      }

      setLoadingPhoneRows((prev) => ({
        ...prev,
        [uiRowId]: true,
      }));

      const post_view = {
        person_id: uiRowId,
        provider: provider || "apollo",
      };

      const requestOption = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(post_view),
      };

      const resp = await dispatch(loadGetPhone(requestOption));
      const person = Array.isArray(resp) ? resp[0] : null;

      console.log("PHONE UNLOCK RESPONSE =>", person);

      // ---------- SalesTarget: sync result, no webhook ----------
      if ((provider || "apollo") === "salestarget") {
        if (person) {
          const updatedData = searchContactData.map((item) => {
            if (item.id !== person.id && item.id !== uiRowId) return item;
            return {
              ...item,
              email: person.email || item.email,
              phone: person.phone,
              name: person.name || item.name,
              first_name: person.first_name,
              last_name: person.last_name,
              title: person.title || item.title,
              organization: person.organization || item.organization,
              city: person.city || item.city,
              state: person.state || item.state,
              country: person.country || item.country,
              has_email: !!person.email,
              has_phone: !!person.phone,
              saved_status: true,
              provider: "salestarget",
              full_person: person.full_person || person,
            };
          });
          dispatch(updateAisearchedContacts(updatedData));

          // Insert into Oracle with full enriched person
          await insertEnrichedContact(person);
        } else if (resp && resp.error) {
          toast.error(resp.error);
        }

        setLoadingPhoneRows((prev) => ({
          ...prev,
          [uiRowId]: false,
        }));
        return;
      }

      // ---------- Apollo: empty enrich ----------
      if (
        person &&
        person.first_name == null &&
        person.email == null &&
        person.phone == null &&
        person.last_name == null
      ) {
        const updatedData = searchContactData.map((item) => {
          if (item.id !== person.id && item.id !== uiRowId) return item;
          return {
            ...item,
            email: person.email,
            state: person.state,
            city: person.city,
            country: person.country,
            zipcode: person.zipcode,
            saved_status: true,
          };
        });
        dispatch(updateAisearchedContacts(updatedData));

        setLoadingPhoneRows((prev) => ({
          ...prev,
          [uiRowId]: false,
        }));
        return;
      }

      // ---------- Apollo: webhook once ----------
      startProgressTracking(resp, uiRowId);
    } catch (err) {
      if (err.name === "AbortError") {
        console.log("Previous request aborted ✅");
      } else {
        console.log(err);
        toast.error("Phone unlock failed");
      }
      setLoadingPhoneRows((prev) => ({
        ...prev,
        [uiRowId]: false,
      }));
    } finally {
      console.log("finished");
    }
  };
  const startProgressTracking = (resp, uiRowId) => {
    const interval = setInterval(async () => {
      const completed = await getAllUnlockedPhones(resp, uiRowId, interval);
      if (completed) {
        clearInterval(interval);
      }
    }, 10000);
  };

  let interval_count = 0;
  const getAllUnlockedPhones = async (resp, uiRowId, interval) => {
    const response = await fetch(`${aiBaseUrl}ai/check-webhook-status`);
    const data = await response.json();
    interval_count = interval_count + 1;

    if (data.total !== 0) {
      clearInterval(interval);
      const insertData = {
        person_id: uiRowId,
        user_id: parseInt(signInDetails[0].id),
        user_name: signInDetails[0].name,
        sbn_id: signInDetails[0].sbn_id,
        list_name: "Default",
      };

      const requestOption = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(insertData),
      };

      dispatch(webHookGetPhone(requestOption))
        .then((response) => {
          if (response.success === true) {
            const updatedData = searchContactData.map((item) => {
              if (item.id === resp[0].id) {
                return {
                  ...item,
                  email: resp[0].email,
                  phone: response.mobile,
                  state: resp[0].state,
                  city: resp[0].city,
                  country: resp[0].country,
                  zipcode: resp[0].zipcode,
                  saved_status: true,
                };
              }
              return item;
            });
            dispatch(updateAisearchedContacts(updatedData));
          } else {
            const updatedData = searchContactData.map((item) => {
              if (item.id === resp[0].id) {
                return {
                  ...item,
                  email: resp[0].email,
                  phone: "NA",
                  state: resp[0].state,
                  city: resp[0].city,
                  country: resp[0].country,
                  zipcode: resp[0].zipcode,
                  saved_status: true,
                };
              }
              return item;
            });
            dispatch(updateAisearchedContacts(updatedData));
          }
          setLoadingPhoneRows((prev) => ({
            ...prev,
            [uiRowId]: false,
          }));
        })
        .catch((err) => {
          if (err.name === "AbortError") {
            console.log("Previous request aborted ✅");
          } else {
            console.log(err);
          }
          setLoadingPhoneRows((prev) => ({
            ...prev,
            [uiRowId]: false,
          }));
        });
      return true;
    }

    if (interval_count >= 10) {
      clearInterval(interval);
      setLoadingPhoneRows((prev) => ({
        ...prev,
        [uiRowId]: false,
      }));
      return true;
    }
    return false;
  };
  // endregion

  // region unlock email
  const handleEmailUnlock = async (uiRowId, type, provider = "apollo") => {
    let textVal = "1 credit will be used to unlock this email.";
    let title = "Unlock Email?";
    if (type === "enrich") {
      textVal = "1 credit will be used to enrich this record.";
      title = "Unlock Contact?";
    }

    const result = await Swal.fire({
      title,
      html: `
      <div style="text-align: center; line-height: 1.6;">
        <p style="font-size: 16px; color: #555; margin-bottom: 20px;">${textVal}</p>
        <p style="font-size: 14px; color: #64748b;">
          Proceeding will deduct these credits from your account.
        </p>
      </div>
    `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Unlock",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#2563eb",
      cancelButtonColor: "#dc2626",
      reverseButtons: true,
      focusCancel: true,
      width: "500px",
    });

    if (!result.isConfirmed) return;

    try {
      if (getCredits.credits_aval <= 0) {
        toast.warning("You dont have enough credits to unlock the email. Please upgrade the plan");
        return;
      }

      setLoadingRows((prev) => ({ ...prev, [uiRowId]: true }));

      const requestOption = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          person_id: uiRowId,
          provider: provider || "apollo",
        }),
      };

      const resp = await dispatch(loadEnrichData(requestOption));
      const person = Array.isArray(resp) ? resp[0] : null;

      console.log("ENRICH RESPONSE =>", person);

      if (!person) {
        if (resp?.error) toast.error(resp.error);
        return;
      }

      // Update table
      const updatedData = searchContactData.map((item) => {
        if (item.id !== person.id && item.id !== uiRowId) return item;
        return {
          ...item,
          email: person.email || item.email,
          // phone: person.phone || item.phone,
          name: person.name || item.name,
          first_name: person.first_name,
          last_name: person.last_name,
          title: person.title || item.title,
          organization: person.organization || item.organization,
          city: person.city || item.city,
          state: person.state || item.state,
          country: person.country || item.country,
          has_email: !!person.email,
          // has_phone: !!person.phone,
          saved_status: true,
          provider: person.provider || provider || "apollo",
          full_person: person.full_person || person,
        };
      });
      dispatch(updateAisearchedContacts(updatedData));

      // Insert into Oracle (both providers)
      await insertEnrichedContact(person);
    } catch (err) {
      if (err.name !== "AbortError") {
        console.error(err);
        toast.error("Email unlock failed");
      }
    } finally {
      setLoadingRows((prev) => ({ ...prev, [uiRowId]: false }));
    }
  };
  // endregion

  // region skeleton / cells
  const renderSkeletonCell = (params) => {
    if (params.row?.isSkeleton) {
      return <Skeleton variant="text" width="100%" />;
    }

    // if (params.field === "phone") {
    //   return params?.row?.phone === "NA" ||
    //     params?.row?.phone === null ||
    //     params?.row?.phone === "-" ? (
    //     <span
    //       style={{
    //         color: "#007bff",
    //         cursor: "pointer",
    //         display: "flex",
    //         alignItems: "center",
    //       }}
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         handlePhoneUnlock(
    //           params.row.apiId,
    //           params?.row?.saved_status,
    //           params.row.provider
    //         );
    //       }}
    //     >
    //       {loadingPhoneRows[params.row.apiId] ? (
    //         <div>
    //           <CircularProgress size={16} />
    //         </div>
    //       ) : (
    //         <div>
    //           <Tooltip
    //             title={
    //               params?.row?.saved_status === false
    //                 ? `Email and Phone will be enriched. Enrichment can use 9 credit for phone and free for email if available.`
    //                 : `Phone will be enriched. Enrichment can use 9 credit for phone.`
    //             }
    //             arrow
    //             placement="top"
    //           >
    //             <span className="unlock-item">
    //               <i className="fa fa-phone" style={{ marginRight: 8 }}></i>
    //               Unlock Phone
    //             </span>
    //           </Tooltip>
    //         </div>
    //       )}
    //     </span>
    //   ) : (
    //     <div>
    //       {params.value !== "-" && params.value !== "NA" ? (
    //         <span className="locked_value">
    //           <i className="fa fa-phone" style={{ marginRight: 8 }}></i>
    //           {params.value}
    //         </span>
    //       ) : (
    //         <span className="no-value-item"> NA</span>
    //       )}
    //     </div>
    //   );
    // }

    if (params.field === "phone") {
      const phone = params.row.phone;
      const hasPhone = params.row.has_phone; // can be true / false / undefined

      // Show Unlock button only when phone is missing AND we still think a phone might exist
      // OR when it is still the old locked state
      const shouldShowUnlock =
        (phone === "NA" || phone === null || phone === "-" || phone === "") &&
        hasPhone !== false; // ← important: if has_phone is false → do NOT show unlock

      if (shouldShowUnlock) {
        return (
          <span
            style={{
              color: "#007bff",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
            }}
            onClick={(e) => {
              e.stopPropagation();
              handlePhoneUnlock(
                params.row.apiId,
                params?.row?.saved_status,
                params.row.provider
              );
            }}
          >
            {loadingPhoneRows[params.row.apiId] ? (
              <div>
                <CircularProgress size={16} />
              </div>
            ) : (
              <div>
                <Tooltip
                  title={
                    params?.row?.saved_status === false
                      ? `Email and Phone will be enriched. Enrichment can use 9 credit for phone and free for email if available.`
                      : `Phone will be enriched. Enrichment can use 9 credit for phone.`
                  }
                  arrow
                  placement="top"
                >
                  <span className="unlock-item">
                    <i className="fa fa-phone" style={{ marginRight: 8 }}></i>
                    Unlock Phone
                  </span>
                </Tooltip>
              </div>
            )}
          </span>
        );
      }

      // Real phone
      if (phone && phone !== "NA" && phone !== "-" && phone !== null) {
        return (
          <div>
            <span className="locked_value">
              <i className="fa fa-phone" style={{ marginRight: 8 }}></i>
              {phone}
            </span>
          </div>
        );
      }

      // No phone (has_phone === false or empty after unlock)
      // return <span className="no-value-item">N/A</span>;
    }

    if (params.field === "email") {
      return params?.row?.has_email === true &&
        (params?.row?.email === "NA" || params?.row?.email === "-") ? (
        <span
          style={{
            color: "#007bff",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleEmailUnlock(
              params.row.apiId,
              undefined,
              params.row.provider
            );
          }}
        >
          {loadingRows[params.row.apiId] ? (
            <div>
              <CircularProgress size={16} />
            </div>
          ) : (
            <div>
              <Tooltip
                title="Enrichment uses 1 credit per email record"
                arrow
                placement="top"
              >
                <span className="unlock-item">
                  <span style={{ marginRight: 8 }}>{emailAccessSuccess}</span>
                  Unlock
                </span>
              </Tooltip>
            </div>
          )}
        </span>
      ) : (
        <div>
          {params.value !== "-" && params.value !== "NA" ? (
            <span className="locked_value">
              <i className="fa fa-envelope" style={{ marginRight: 8 }} />
              {params.value}
            </span>
          ) : (
            <>
              {params?.row?.saved_status === false ? (
                <div>
                  <Tooltip
                    title="No email found for this record."
                    arrow
                    placement="top"
                  >
                    <span className="unlock-item">
                      <span style={{ marginRight: 8, cursor: "help" }}>
                        {emailAccessFail}
                      </span>
                      Unlock
                    </span>
                  </Tooltip>
                </div>
              ) : (
                <div>
                  <span className="unlocked-no-item">
                    <span style={{ marginRight: 8, cursor: "help" }}>
                      {emailAccessFail}
                    </span>
                    No Email
                  </span>
                </div>
              )}
            </>
          )}
        </div>
      );
    }


    return params.value || "NA";
  };
  // endregion

  const columns = [
    { field: "id", headerName: "ID", width: 70, renderCell: renderSkeletonCell },
    {
      field: "name",
      headerName: "Name",
      width: 130,
      renderCell: renderSkeletonCell,
    },
    {
      field: "title",
      headerName: "Title",
      width: 220,
      renderCell: renderSkeletonCell,
    },
    {
      field: "company",
      headerName: "Company",
      width: 200,
      renderCell: renderSkeletonCell,
    },
    {
      field: "phone",
      headerName: "Phone",
      width: 160,
      renderCell: renderSkeletonCell,
    },
    {
      field: "email",
      headerName: "Email",
      width: 260,
      renderCell: renderSkeletonCell,
    },
    {
      field: "city",
      headerName: "City",
      width: 130,
      renderCell: renderSkeletonCell,
    },
    {
      field: "state",
      headerName: "State",
      width: 130,
      renderCell: renderSkeletonCell,
    },
    {
      field: "country",
      headerName: "Country",
      width: 130,
      renderCell: renderSkeletonCell,
    },
  ];

  const transformSearchContactData = (data) => {
    return data.map((item, index) => {
      // ---------- EMAIL ----------
      let email = item.email;
      let hasEmail = item.has_email;

      if (
        email === "***@***.com" ||
        (typeof email === "string" && email.startsWith("***@"))
      ) {
        email = "NA";
        hasEmail = true;
      }
      else if (
        email == null ||
        email === "null" ||
        email === "" ||
        email === "NA" ||
        email === "-"
      ) {
        email = "NA";
        hasEmail = true;
        
      }
      else if (email && email !== "NA" && email !== "-") {
        hasEmail = true;
      } else {
        email = email || "NA";
        // Only mark as unavailable when API explicitly says no
        hasEmail =
          hasEmail !== false &&
          hasEmail !== "false" &&
          hasEmail !== "no" &&
          hasEmail !== "No";
      }

      // ---------- PHONE ----------
      let phone = item.phone;
      let hasPhone = item.has_phone;

      if (
        phone === "****" ||
        phone === "***" ||
        (typeof phone === "string" && phone.includes("*"))
      ) {
        phone = "NA";
        hasPhone = true;
      } else if (phone && phone !== "NA" && phone !== "-") {
        hasPhone = true;
      } else {
        phone = phone || "NA";
        hasPhone =
          hasPhone !== false &&
          hasPhone !== "false" &&
          hasPhone !== "no" &&
          hasPhone !== "No" &&
          hasPhone !== null &&
          hasPhone !== undefined;
      }

      return {
        id: index + 1,
        apiId: item.id,
        provider: item.provider || "apollo",
        name: item.name || "****",
        title: item.title || "****",
        company: item.organization || "****",
        phone,
        email,
        city: item.city || "****",
        state: item.state || "****",
        country: item.country || "****",
        status: item.email_status === null ? "Not Verified" : "Verified",
        has_email: !!hasEmail,   // force real boolean
        has_phone: !!hasPhone,   // force real boolean
        saved_status: item.saved_status,
      };
    });
  };

  const rows = loadingSearch
    ? Array.from({ length: 16 }).map((_, index) => ({
      id: index + 1,
      apiId: null,
      firstName: "",
      lastName: "",
      jobLevel: "",
      jobDepartment: "",
      title: "",
      company: "",
      website: "",
      phone: "",
      email: "",
      industry: "",
      subIndustry: "",
      technology: "",
      city: "",
      state: "",
      country: "",
      zipCode: "",
      sicCode: "",
      revenue: "",
      employee: "",
      isverified: "",
      updatedDate: "",
      status: "",
      isSkeleton: true,
    }))
    : transformSearchContactData(searchContactData);

  React.useEffect(() => {
    if (!isSelectAll) return;

    setSelectedRowIds((prev) => {
      const currentIds = rows.map((row) => row.id);
      if (
        prev.length === currentIds.length &&
        prev.every((id, index) => id === currentIds[index])
      ) {
        return prev;
      }
      return {
        type: "include",
        ids: new Set(currentIds),
      };
    });

    setSelectedRowsData((prev) => {
      if (prev.length === rows.length) {
        return prev;
      }
      return rows;
    });
  }, [rows.length, isSelectAll]);

  const paginatedRows = rows;
  const scrollContainerRef = React.useRef(null);

  React.useEffect(() => {
    const container = document.querySelector(".MuiDataGrid-virtualScroller");
    if (!container) return;

    let lastScrollTop = 0;

    const handleScroll = () => {
      if (!container || loadingMore) return;
      const currentScrollTop = container.scrollTop;
      if (currentScrollTop <= lastScrollTop) return;
      lastScrollTop = currentScrollTop;
      const distanceFromBottom =
        container.scrollHeight - currentScrollTop - container.clientHeight;
      if (
        distanceFromBottom < 10 &&
        searchContactData.length < totalDataCount &&
        !loadingMore
      ) {
        setLoadingMore(true);
        setPage((prev) => prev + 1);
      }
    };

    container.addEventListener("scroll", handleScroll);
    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingMore, searchContactData.length, totalDataCount, setPage]);

  return (
    <>
      <div style={{ position: "relative" }}>
        <Box sx={{ width: "100%", mt: 2 }}>
          <DataGrid
            columnHeaderHeight={45}
            rowHeight={45}
            sx={{ height: `${tableHeight}px !important` }}
            ref={scrollContainerRef}
            pagination={false}
            rowCount={totalDataCount}
            paginationMode="server"
            rows={paginatedRows}
            columns={columns}
            hideFooter
            checkboxSelection
            className="search-contact-data-grid"
            getRowId={(row) => row.id}
            onRowClick={(row) => row.id}
            getRowClassName={(params) =>
              params.row?.isSkeleton ? "skeleton-row" : ""
            }
            onRowSelectionModelChange={(newSelection) => {
              let updatedIds = [];
              if (newSelection.type === "exclude") {
                const excludedIds = Array.from(newSelection.ids);
                updatedIds = paginatedRows
                  .map((row) => row.id)
                  .filter((id) => !excludedIds.includes(id));
                setIsSelectAll(true);
              } else {
                updatedIds = Array.from(newSelection.ids || []);
                const allLoadedIds = paginatedRows.map((row) => row.id);
                const selectAllClicked =
                  allLoadedIds.length > 0 &&
                  allLoadedIds.every((id) => updatedIds.includes(id));
                setIsSelectAll(selectAllClicked);
              }
              setSelectedRowIds({
                type: "include",
                ids: new Set(updatedIds),
              });
              const selectedData = paginatedRows.filter((row) =>
                updatedIds.includes(row.id)
              );
              setSelectedRowsData(selectedData);
            }}
            rowSelectionModel={selectedRowIds}
            loading={loadingSearch}
            disableRowSelectionOnClick
          />
          {loadingMore && (
            <div className="loader-css">
              <div className="d-flex justify-content-center align-items-center py-4">
                <Circles
                  height="30"
                  width="30"
                  color="#007bff"
                  ariaLabel="circles-loading"
                  visible={true}
                />
              </div>
            </div>
          )}
        </Box>
        <AddToListModal
          show={showAddToListModal}
          onHide={() => setShowAddToListModal(false)}
          selectedContacts={selectedRowsData}
          setSelectedRowsData={setSelectedRowsData}
          signInDetails={signInDetails}
          dispatch={dispatch}
          paginatedRows={paginatedRows}
          setSelectedRowIds={setSelectedRowIds}
          searchContactData={searchContactData}
          setIsSelectAll={setIsSelectAll}
        />
      </div>
      {responseTime !== null && (
        <div className="mt-2 text-muted response-time-div">
          Response Time:{" "}
          <strong className="response-time">{responseTime}</strong> ms
        </div>
      )}
    </>
  );
}